import axios from "axios";
import { baseURL } from "../../services/api";
import { attachLoadingInterceptors } from "../../services/loadingBar";

let tokensData = JSON.parse(localStorage.getItem("tokens"));

 
const jwtInterceoptor = axios.create({
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/json',
      "Authorization": `bearer ${tokensData ? tokensData.access_token : ""}`
    }
});

attachLoadingInterceptors(jwtInterceoptor);
 
// jwtInterceoptor.interceptors.request.use((config) => {
//   let tokensData = JSON.parse(localStorage.getItem("tokens"));
//   config.headers.common["Authorization"] = `bearer ${tokensData.access_token}`;
//   return config;
// });

jwtInterceoptor.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {

//  Maintenance mode handling for JWT requests

if (
    error.response?.status === 503 &&
    error.response?.data?.maintenance === true
) {
    sessionStorage.setItem(
        "maintenanceMessage",
        error.response.data.message
    );

    window.location.href = "/maintenance";
    return;
}

      if (error.response?.status === 401) {
        localStorage.removeItem("tokens");
        localStorage.removeItem("orgs");
        window.location.reload();
        return;
        // const authData = JSON.parse(localStorage.getItem("tokens"));
        // const payload = {
        //   access_token: authData.access_token,
        //   //refresh_token: authData.refreshToken,
        // };
   
        // // let apiResponse = await axios.post(
        // //   "http://localhost:4000/auth/refreshtoken",
        // //   payload
        // // );
        // let apiResponse = await jwtInterceoptor.post("/auth/refresh", payload);

        // localStorage.setItem("tokens", JSON.stringify(apiResponse.data));
        // error.config.headers[
        //   "Authorization"
        // ] = `bearer ${apiResponse.data.access_token}`;
        // return axios(error.config);
      } else {
        return Promise.reject(error);
      }
    }
  );

export default jwtInterceoptor;